import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import AngledBracket_Left_Blue from '../../assets/images/svg/AngledBracket-Left-Blue.svg'
import AngledBracket_Right_Grey from '../../assets/images/svg/AngledBracket-Right-Grey.svg'
import Store_Icon_White from '../../assets/images/svg/Store-Icon-White.svg'
import { location } from './locationSlice';
import { getShopName, get_UDid, get_userName } from '../common/localSettings';
import LocalizedLanguage from '../../settings/LocalizedLanguage';
import STATUSES from "../../constants/apiStatus";
import { useNavigate } from 'react-router-dom';
import { LoadingModal } from "../common/commonComponents/LoadingModal";
import { register } from "../register/registerSlice";
import { NavigateComponent, RememberData } from "../../settings/CommonModuleJS";
import { Markup } from "interweave";
import { sendDataToWrapper } from "../../settings/AndroidIOSConnect";
import { useRef } from "react";
import { notificationStatus } from "../../settings/CommonWork";
const Location = () => {
    const registerHide = useRef();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isNoRegister, setisNoRegister] = useState(false);
    const [isLoading, setisLoading] = useState(false);
    var decodedString = localStorage.getItem('UDID');
    var decod = decodedString ? atob(decodedString) : '';
    var UDID = decod;
    var userId = localStorage.getItem('userId') ? localStorage.getItem('userId') : 0;

    const { status, data, error, is_success } = useSelector((state) => state.location);

    const [respRegister] = useSelector((state) => [state.register]);
    // console.log("status", status, "data", data, "error", error, "is_success", is_success)
    useEffect(() => {
        if(notificationStatus()==false|| localStorage.getItem("hasNotifyPermission")=='false')
        {     navigate('/enablenotification?page=location');
            return;
        }
    })
    useEffect(() => {
        // if(notificationStatus()=='false')
        // {
        //     navigate('/enablenotification?page=location');
        //     return;
        // }
        if (respRegister.status == STATUSES.error) {
            console.log(error)
        }
        if (respRegister.status == STATUSES.IDLE && respRegister.is_success && respRegister.data && isLoading === true) {
            setisLoading(false);
            if (respRegister.data.content && respRegister.data.content.length > 0) {
              var  registers = respRegister.data && respRegister.data.content && respRegister.data.content.filter(a => a.IsSelfCheckout === false);
              if(registers.length>0){
                    setisNoRegister(false)
                        dispatch(register(null));
                        navigate('/register')
                    }else{
                        setisNoRegister(true)
                }
            }
            else if (respRegister.data.content && respRegister.data.content.length == 0 && isNoRegister === false) {
                setisNoRegister(true)
                console.log("data----->" + JSON.stringify(respRegister.data))
            }

        }
    }, [respRegister]);

    useEffect(() => {
        //Trigger this listener when the view has changed
        sendDataToWrapper("current_view", "location", "");
        if (localStorage.getItem("rememberme") && localStorage.getItem("rememberme") == "true") {
            if (localStorage.getItem("remember_data")) {
                RememberData("get")
                NavigateComponent(navigate,'pin');
                return;
            }
        }
        dispatch(location({ "udid": UDID, "userId": userId }));
    }, []);

    const handleSubmit = (item) => {
        sessionStorage.removeItem("backUser")
        localStorage.setItem('Location', item.id);
        localStorage.setItem('LocationName', item.name);
        var getudid = get_UDid('UDID');
        localStorage.setItem(`last_login_location_id_${getudid}`, item.id);
        localStorage.setItem(`last_login_location_name_${getudid}`, item.name);
        localStorage.setItem('WarehouseId', item.warehouse_id);
        setisLoading(true);
        dispatch(register({ "id": item.id }));
        // if (item.id) {
        //     navigate('/register')
        // }
    }
    // let {content} = data && data;
    const backFun = () =>{
        sessionStorage.setItem("backUser",true)
        navigate('/site')
    }
    let {content} = data && data;
    useEffect(() =>{

        if(content && content.length === 1 && !sessionStorage.getItem("backUser")){
            console.log(content.length);
            handleSubmit(content[0]);
        }
        setTimeout(() => {            
            if((content && content.length > 1) || sessionStorage.getItem("backUser") ){
                    if(registerHide.current && registerHide.current.classList)
                    registerHide.current.classList.remove('hide_wrapper')
                }
        }, 1000);
    },[content])
    const handleRefresh=()=>{
        dispatch(location({ "udid": UDID, "userId": userId }));
    }
        return <React.Fragment>{status == STATUSES.LOADING || respRegister.status == STATUSES.LOADING ? <LoadingModal></LoadingModal> : null}
        
        <div className={(is_success ==false && error && error !== "" )? "choose-wrapper ":"choose-wrapper hide_wrapper"} ref={registerHide}>
        <div className="choose-header">
            <button id="backButton" onClick={backFun}>
                <img src={AngledBracket_Left_Blue} alt="" />
                {LocalizedLanguage.back}
            </button>
            <p>{getShopName()}</p>
        </div>
    
        <div className="choose-body-default">
        {(status == STATUSES.ERROR && error && error !== "") &&
                    <div className="custom-error-message user-info">
                        {error}
                    </div>}
            <p>{LocalizedLanguage.chooseLocation}</p>           
            <div className="divider"></div>
             {(status == STATUSES.ERROR && error && error !== "") &&
                <span className="location-refresh-button" onClick={handleRefresh}>Try again</span>
             }
            <div className="button-container">

                {data !== null && data.content !== undefined &&
                    data.content.map((item, index) => {
                        return (
                            
                            <button key={index} className="option" onClick={() => handleSubmit(item)}>
                                <div className="img-container background-blue">
                                    <img src={Store_Icon_White} alt="" className="store-icon" />
                                </div>
                                <div className="col">
                                    <p className="style1"><Markup content={item.name} noWrap={true}></Markup></p>
                                </div>
                                <img src={AngledBracket_Right_Grey} alt="" />
                                <div className="fake-button background-blue">{LocalizedLanguage.select}</div>
                            </button>
                        )
                    })}
               
            </div>
            
             {isNoRegister === true && <p className="error" style={{ fontSize: "unset" }} >{LocalizedLanguage.notSetectLocation} </p>}
        </div>
    </div>
    </React.Fragment>
}
export default Location